import React from "react";

export function GradientDivider() {
    return (
        <div className="w-full h-1 my-12 bg-gradient-to-r from-sky-400 via-yellow-400 to-sky-400 rounded-full opacity-70" />
    );
}

export function WaveDivider() {
    return (
        <div className="w-full overflow-hidden leading-none">
            <svg viewBox="0 0 1200 80" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-12">
                <path d="M0 40 Q 300 80 600 40 T 1200 40 V80 H0 V40Z" fill="url(#waveGradient)" />
                <defs>
                    <linearGradient id="waveGradient" x1="0" y1="0" x2="1200" y2="0" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#38bdf8" />
                        <stop offset="0.5" stopColor="#fde047" />
                        <stop offset="1" stopColor="#38bdf8" />
                    </linearGradient>
                </defs>
            </svg>
        </div>
    );
} 